/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ROUTE_PREFIX } from '../src/constants';

const childRoutes = [];

export const passSelectionBySite = (siteId) => `${ROUTE_PREFIX}/${siteId}`;
export const detailsRoute = (siteId) => `${passSelectionBySite(siteId)}`;
export const detailsScannedRoute = (siteId) => `${passSelectionBySite(siteId)}/scanned`;
export const passSelectionRoute = (siteId) => `${passSelectionBySite(siteId)}/order`;
export const passSelectionRouteWithReservation = (siteId, resId) =>
    `${passSelectionBySite(siteId)}/order/reservation/${resId}`;
export const passSelectionRouteWithPassType = (siteId, passTypeId) =>
    `${passSelectionBySite(siteId)}/order/${passTypeId}`;

// UPDATING a reservation
childRoutes[childRoutes.length] = {
    path: passSelectionRouteWithReservation(':siteId', ':resId'),
    componentName: 'PassSelectionPage',
    title: 'Pass Selection',
};

// FOCUSING on a pass type
childRoutes[childRoutes.length] = {
    path: passSelectionRouteWithPassType(':siteId', ':passTypeId'),
    componentName: 'PassSelectionPage',
    title: 'Pass Selection',
};

// SELECTING PASS TYPES for a site / UPDATING an order
childRoutes[childRoutes.length] = {
    path: passSelectionRoute(':siteId'),
    componentName: 'PassSelectionPage',
    title: 'Pass Selection',
};

childRoutes[childRoutes.length] = {
    path: detailsRoute(':siteId'),
    componentName: 'ActivityPassDetailsPageContainer',
    title: 'Pass Details Page',
};

childRoutes[childRoutes.length] = {
    path: detailsScannedRoute(':siteId'),
    componentName: 'ActivityPassDetailsPageContainer',
    title: 'Pass Details Page',
};

export default childRoutes;
